import { switchTenant } from 'probonio-shared-ui/module/me';
import { useCallback } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { resetEmployeeFilter, resetSorting, setTabIndex } from '../userManagement/filter';

/**
 * Switches the manager to another tenant and drops the list state (filter, sorting, tab) that belonged to the
 * previous one. `remember: false` keeps the last selected tenant as it is (see `switchTenant`).
 */
export function useSwitchTenant(): (tenantId: string, options?: { remember?: boolean }) => void {
  const dispatch = useAppDispatch();

  return useCallback(
    (tenantId: string, options?: { remember?: boolean }) => {
      dispatch(switchTenant({ tenantId, isAdmin: true, remember: options?.remember }));
      dispatch(resetSorting());
      dispatch(resetEmployeeFilter());
      dispatch(setTabIndex(0));
    },
    [dispatch],
  );
}
